module.exports = __webpack_public_path__ + "05d475c6a82e58cf244efb77450888f6.jpg";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/img/ESRB_rating_pending.jpg
// module id = 146
// module chunks = 0